// frontend/src/components/client/ClientStatsCards.jsx
import React from 'react';
import { Fuel, Wrench, CreditCard, Calendar, RefreshCw } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, onClick }) => (
  <div 
    onClick={onClick}
    className="bg-gray-800/50 rounded-xl border border-gray-700 p-4 cursor-pointer hover:bg-gray-800/70 transition"
  >
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-400 text-sm">{title}</p>
        <p className="text-2xl font-bold text-white mt-1">{value}</p>
      </div>
      <div className={`p-3 rounded-lg ${color}`}>
        <Icon className="w-5 h-5" />
      </div>
    </div>
  </div>
);

const ClientStatsCards = ({ stats, loading, onRefresh }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1,2,3,4].map(i => (
          <div key={i} className="bg-gray-800/50 rounded-xl border border-gray-700 p-4 animate-pulse">
            <div className="h-16 bg-gray-700/50 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-end mb-4">
        <button 
          onClick={onRefresh}
          className="p-2 hover:bg-gray-700 rounded-lg text-gray-400"
        >
          <RefreshCw className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard 
          title="Demandes carburant" 
          value={stats?.fuel_requests_pending || 0}
          icon={Fuel}
          color="bg-orange-500/20 text-orange-400"
        />
        <StatCard 
          title="Demandes maintenance" 
          value={stats?.maintenance_requests_pending || 0}
          icon={Wrench}
          color="bg-red-500/20 text-red-400"
        />
        <StatCard 
          title="Factures impayées" 
          value={`${stats?.invoices_pending_count || 0} (${stats?.invoices_pending_total || 0}€)`}
          icon={CreditCard}
          color="bg-yellow-500/20 text-yellow-400"
        />
        <StatCard 
          title="Événements à venir" 
          value={stats?.upcoming_events || 0}
          icon={Calendar}
          color="bg-blue-500/20 text-blue-400"
        />
      </div>
    </div>
  );
};

export default ClientStatsCards;